import { useTranslation } from 'react-i18next';

import { normalizeMessage } from '../actions';
import { useWidgetContext } from 'widget/widget-context';
import { WIDGET_URL } from 'widget/constants/widget-url';
import * as Env from 'widget/env';

const useWelcomeMessages = (): Env.Message[] | null => {
  const { widget } = useWidgetContext();
  const { t } = useTranslation();

  if (!widget.welcome_messages?.length) return null;

  const messages = widget.welcome_messages.map(message =>
    normalizeMessage(
      message,
      t`Manager`,
      `${WIDGET_URL}/static/img/manager.svg`,
    ),
  );

  return messages;
};

export default useWelcomeMessages;
